import get from 'lodash.get';

const getBlocks = (rootState) => get(rootState, 'ws.template.meta.blocks', []);

export default getBlocks;
